import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';

import CustomScrollbars from './CustomScrollbars';
import SearchSupplier from '../components/Search/SearchSupplier';
import { SUPPLIER_DETAIL, CLIENTS_DETAIL } from '../constants/routes';
import { TYPE_SUPPLIER } from '../constants/clientTypes';

class WaitForCallPanel extends Component {
	render () {
		const { list, className } = this.props;
		return (
			<div>
				{list.map((call_group, i)=>
					<div className={`col-xs-12 panel panel-${ className }`} key={ i }>
						<div className="panel-heading">
							<h4 className="panel-title">{ call_group.will_callee_name }</h4>
						</div>
						<div className="panel-body">
							<CustomScrollbars autoHeight autoHeightMin={ 50 } autoHeightMax={ 250 }>
								<div className="row">
									<div className="col-xs-12">
										<h5>Поставщики</h5>
										{call_group.calls && call_group.calls.supplier ? call_group.calls.supplier.map(client =>
											<SearchSupplier key={ client.id } client={ client }/>) 
											: <div className="inwork-item"><span className="inwork-date"> </span>(список пуст)</div> }
									</div>
								</div>
							</CustomScrollbars>
						</div>
					</div>
				)}
			</div>
		);
	}
}

WaitForCallPanel.propTypes = {
	list: PropTypes.array.isRequired,
	className: PropTypes.string
};

export default WaitForCallPanel;


// WEBPACK FOOTER //
// ./components/WaitForCallPanel.js